import { useCallback, useEffect } from 'react';
import { GLOBAL_SEARCH_COMPONENT, globalSearchComponentDef } from 'navigation-components/config';
import { useComponentState, useInvokeFunction, useToggleComponent } from 'navigation-components/platform/hooks';
import { isKeyboardShortcut } from 'global-search-shared/utils/isKeyboardShortcut';
import { SEARCH_TRACKING_CONSTANTS, handleError } from '../constants';
const useKeyboardShortcutsSearch = ({
  searchInput,
  trackSearchEvent
}) => {
  const {
    invoke
  } = useInvokeFunction(globalSearchComponentDef);
  const searchComponentState = useComponentState(GLOBAL_SEARCH_COMPONENT);
  const {
    toggle
  } = useToggleComponent(GLOBAL_SEARCH_COMPONENT);
  const resultsNavigationHandler = useCallback(event => {
    if (searchComponentState.isReady && searchComponentState.isOpen) {
      const {
        isValidShortcut,
        isGlobal
      } = isKeyboardShortcut(event);
      if (!isValidShortcut || isGlobal) {
        if (event.key === 'Escape' && searchInput.current && searchInput.current.value.length === 0) {
          toggle();
          trackSearchEvent({
            type: SEARCH_TRACKING_CONSTANTS.CLOSE,
            value: SEARCH_TRACKING_CONSTANTS.ESCAPE
          });
        } else if (event.key === 'Tab') {
          invoke('keyDown', {
            keyboardEventKeys: {
              altKey: event.altKey,
              ctrlKey: event.ctrlKey,
              metaKey: event.metaKey,
              shiftKey: event.shiftKey,
              key: event.key
            }
          }).catch(handleError);
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (!isGlobal) {
        invoke('keyDown', {
          keyboardEventKeys: {
            altKey: event.altKey,
            ctrlKey: event.ctrlKey,
            metaKey: event.metaKey,
            shiftKey: event.shiftKey,
            key: event.key
          }
        }).catch(handleError);
      }
    }
  }, [invoke, searchComponentState.isOpen, searchComponentState.isReady, searchInput, toggle, trackSearchEvent]);
  useEffect(() => {
    const current = searchInput.current;
    if (current) {
      current.addEventListener('keydown', resultsNavigationHandler);
    }
    return () => {
      if (current) {
        current.removeEventListener('keydown', resultsNavigationHandler);
      }
    };
  }, [resultsNavigationHandler, searchInput]);
};
export default useKeyboardShortcutsSearch;